<template>
  <div v-loading="contentLoading">
    <div class="title">
      基本信息
    </div>
    <table cellspacing="0" cellpadding="0" style="width: 100%" class="purchasePlanTable">
      <tr>
        <td class="tableLabel">申请编号</td>
        <td class="tableContent">
          <el-input v-model="form.billNo" placeholder="系统自动生成" disabled style="width: 300px"/>
        </td>
        <td class="tableLabel">标题</td>
        <td class="tableContent">
          <el-input v-model="form.billTitle" placeholder="请输入内容" style="width: 300px"/>
        </td>
        <td class="tableLabel">是否加急</td>
        <td class="tableContent">{{form.urgent ? "是" : "否"}}</td>
      </tr>
    </table>
    <div
        style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
      <div>明细信息</div>
    </div>
    <el-table default-expand-all :data="form.details" border>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-descriptions :column="4">
            <!-- v-if="props.row.materialNo === item.materialNo && props.row.requireDeliveryDate === item.thisWeekDeliveryDate" -->
            <template>
              <el-descriptions-item
                  label="发货单号">
                {{props.row.deliveryBillNo}}
              </el-descriptions-item>
              <el-descriptions-item
                  label="需求数量">
                <span class="total-number">{{props.row.nextGap}}</span>
                <span style="margin-left: 10px;">
                  (<span class="total-number">建议采购量：{{getClosestMultiples(props.row.roundedValue, props.row.minPackQty, props.row.nextGap).join('、')}}</span>)
                </span>
              </el-descriptions-item>
              <el-descriptions-item
                  label="最小包装量">
                <span class="total-number">{{props.row.minPackQty}}</span>
              </el-descriptions-item>
              <el-descriptions-item
                  label="舍入值">
                <span class="total-number">{{props.row.roundedValue}}</span>
              </el-descriptions-item>
            </template>
          </el-descriptions>
          <el-table
              :data="props.row.details"
              style="width: 100%;margin-top: 3px"
              show-summary
              :summary-method="getSummary"
          >
            <el-table-column
                prop="materialNo"
                align="center"
                label="物料编号"
                show-overflow-tooltip
                width="120"/>
            <el-table-column
                prop="purchaseOrderNo"
                align="center"
                label="采购订单号"/>
            <el-table-column
                prop="poDetailRowNo"
                align="center"
                label="采购订单行号"/>
            <el-table-column
                prop="purchaseQuantity"
                align="center"
                label="采购订单数量"/>
            <el-table-column
                prop="hasInStorageQty"
                align="center"
                label="已入库数量"/>
            <el-table-column
                prop="createPlanQty"
                align="center"
                label="已创建要货计划的数量"/>
            <el-table-column
                prop="quantity"
                align="center"
                label="要货数量"
                width="150">
              <template slot-scope="scope">
                <el-input-number
                    v-model="scope.row.quantity"
                    style="width: 100%"
                    :min="0"
                    :max="Number(scope.row.purchaseQuantity) - Number(scope.row.createPlanQty)"
                    @change="changeQuantity(scope.row)"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="requireDeliveryDate"
                align="left"
                label="需求日期"
                show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.requireDeliveryDate">{{scope.row.requireDeliveryDate}}</span>
                <span v-else>{{props.row.requireDeliveryDate}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="supplierName"
                align="left"
                width="300"
                label="供应商"/>
            <el-table-column
                prop="supplierCode"
                align="left"
                width="100"
                label="供应商编号"/>
            <el-table-column
                label="操作"
                fixed="right"
                align="center"
                class-name="vm-table_operate"
                width="120">
              <template v-slot="scope">
                <el-button type="danger" @click="deleteDetailRow(props.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
          prop="materialNo"
          align="center"
          label="物料编号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="mappingMaterialNo"
          align="center"
          label="旧物料号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="materialName"
          align="left"
          label="物料描述"
          show-overflow-tooltip/>
      <el-table-column
          prop="requireDeliveryDate"
          align="left"
          label="需求日期"
          show-overflow-tooltip/>
      <el-table-column
          prop="nextGap"
          align="left"
          width="120"
          label="下周缺口数量"/>
      <el-table-column
          label="操作"
          fixed="right"
          align="center"
          class-name="vm-table_operate"
          width="120">
        <template v-slot="scope">
          <el-button type="primary" @click="addDetails(scope.row,scope.$index)">新增</el-button>
          <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 5px">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
      </span>
    </div>
    <purchase-plan-select ref="purchasePlanSelect" @select="selectPurchasePlan"/>
  </div>
</template>

<script>
  import PurchasePlanSelect from "@/views/PurchaseOrderManager/PurchasePlan/PurchasePlanSelect";

  export default {
    name: "PurchasePlanPreview",
    components: {PurchasePlanSelect},
    data() {
      return {
        editSelection: [],
        downLoadLoading: false,
        deliverySelection: [],
        saleOrderSelection: [],
        selection: [],
        contentLoading: false,
        pkid: "",
        type: 1,
        dialogVisible: false,
        submitLoading: false,
        uploadLoading: false,
        edit: 0,
        form: {
          pkid: 0,
          billNo: "",
          note: "",
          details: [],
        },
      };
    },

    watch: {
      $route: {
        handler: function(val) {
          const routeSelectIds = val.query.selection.map(item => item.pkId);
          // 比较两个数组的内容，相同则不刷新页面，不同则刷新页面
          const isEqual = this.editSelection.length === routeSelectIds.length && 
            this.editSelection.every((id, index) => id === routeSelectIds[index]);
          if (val.name === "PurchasePlanPreview" && !isEqual) {
            this.getData(val.query.selection);
            this.editSelection = routeSelectIds;
          }
        },
      },
    },
    mounted() {
      this.form.details = [];
      this.$nextTick(() => {
        this.getData(this.$route.query.selection);
        this.editSelection = this.$route.query.selection.map(item => item.pkId);
      },
      );
    },

    methods: {
      getData(selection) {
        this.form.details = [];
        this.selection = JSON.parse(JSON.stringify(selection));
        selection = this.mergeArrayItems(selection);
        selection.forEach(orderDetail => {
          let detail = {};
          detail.materialNo = orderDetail.materialNo;
          detail.materialName = orderDetail.materialName;
          detail.mappingMaterialNo = orderDetail.mappingMaterialNo;
          detail.nextGap = orderDetail.nextGap;
          detail.requireDeliveryDate = orderDetail.thisWeekDeliveryDate;
          detail.requireId = orderDetail.pkId;
          detail.urgent = orderDetail.urgent;
          detail.planType = orderDetail.planType;
          detail.minPackQty =orderDetail.minPackQty;
          detail.roundedValue =orderDetail.roundedValue;
          this.type = orderDetail.planType;
          detail.deliveryBillNo = orderDetail.deliveryBillNo;
          detail.deliveryDetailIds = orderDetail.deliveryDetailIds;
          this.form.details.push(detail);
        });
        this.initPurchaseOrders();
      },
      mergeArrayItems(list) {
        const mergedList = Array.from(list
          .reduce((map, item) => {
            const key = `${item.materialNo}_${item.thisWeekDeliveryDate}`;
            const existing = map.get(key);

            if (existing) {
              // 合并已存在的项
              existing.deliveryDetailIds = `${existing.pkId},${item.pkId}`;
              existing.nextGap += item.nextGap;
            } else {
              // 创建新项（复制对象）
              map.set(key, {...item, pkId: item.pkId.toString()});
            }

            return map;
          }, new Map())
          .values());
        return mergedList;
      },
      initPurchaseOrders() {
        this.initPurchaseLoading = true;
        this.$http
          .post("basic", "purchasePlans/initPurchasePlan", this.form.details)
          .then((res) => {
            if (res.success) {
              this.form.details = res.data;
            } else {
              this.$bus.$emit("closeTag", this.$route);
              if (this.type === 1) {
                this.$router.push({
                  path: "/PurchaseOrderManager/PurchasePlan/PurchasePlanAdd",
                });
              } else {
                this.$router.push({
                  path: "/PurchaseOrderManager/PurchasePlan/DeliveryPlanAdd",
                });
              }
            }
            this.initPurchaseLoading = false;
          }).catch(() => {
            this.initPurchaseLoading = false;
            this.$bus.$emit("closeTag", this.$route);
            if (this.type === 1) {
              this.$router.push({
                path: "/PurchaseOrderManager/PurchasePlan/PurchasePlanAdd",
              });
            } else {
              this.$router.push({
                path: "/PurchaseOrderManager/PurchasePlan/DeliveryPlanAdd",
              });
            }
          });
      },
      checkQuantity(row) {
        const reg = /^[0-9]*[1-9][0-9]*$/;
        if (!reg.test(row.quantity)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
        if (row.quantity > row.qty - row.planQty) {
          this.$confirm("要货数量超过剩余数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },
      addDetails(row, index) {
        row.initDetails.forEach(detail => {
          detail.isDisabled = false;
        });
        this.$refs.purchasePlanSelect.open(row, index);
      },
      selectPurchasePlan(row, index) {
        this.form.details[index].details.push(row);

      },
      // 删除行项
      deleteRow(index) {
        this.form.details.splice(index, 1);
      },
      deleteDetailRow(row, index) {
        row.details.splice(index, 1);
      },

      oneDelete(index) {
        this.form.details.splice(index, 1);
      },
      // 计算最大公约数
      gcd(a, b) {
        return b === 0 ? a : this.gcd(b, a % b);
      },
      
      // 计算最小公倍数
      lcm(a, b) {
        if (a === 0 || b === 0) return 0;
        return Math.abs(a * b) / this.gcd(a, b) || 1;
      },
      
      changeQuantity(row) {
        if (parseInt(row.roundedValue) === 0) {
          if (row.quantity === 0) {
            this.$message.error("请输入正确的数量!");
          }
        } 

      },
      // 计算接近nextGap的两个公倍数
      getClosestMultiples(roundedValue, minPackQty, nextGap) {
        // 计算roundedValue和minPackQty的最小公倍数
        const baseLcm = this.lcm(roundedValue, minPackQty);
        
        if (baseLcm === 0) {
          return [nextGap];
        }
        
        // 计算接近nextGap的两个公倍数
        const lower = Math.floor(nextGap / baseLcm) * baseLcm;
        const upper = lower + baseLcm;
        
        // 确保结果为正数
        const multiples = [];
        if (lower > 0) {
          multiples.push(lower);
        }
        multiples.push(upper);
        
        return multiples;
      },
      
      // 合计方法
      getSummary({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.property === "quantity") {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },
      saveHandle() {
        let isNext = true;
        this.form.details.forEach(row => {
          row.billTitle = this.form.billTitle;
          row.note = this.form.note;
          // let values = row.details.map(item => Number(item.quantity));
          // let sum = values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          // if (sum < Number(row.nextGap)) {
          //   isNext = false;
          //   this.$message.error("要货数量不能小于需求数量，请确认!");
          // }
          // row.details.forEach(detail => {
          //   let num = Number(detail.purchaseQuantity) - Number(detail.createPlanQty);
          //   if (detail.quantity > num) {
          //     isNext = false;
          //     this.$message.error("要货数量不能大于" + num);
          //   }
          // });
        });
        if (isNext) {
          this.submitLoading = true;
          this.$http
            .post("basic", "purchasePlans/insertPurchasePlans", this.form.details)
            .then(() => {
              this.submitLoading = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
              this.$bus.$emit("closeTag", this.$route);

            })
            .catch(() => {
              this.submitLoading = false;
            });
        }

      },
    },
  };
</script>
<style lang="scss" scoped>
.purchasePlanTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.purchasePlanTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}

.tableContent {
  width: 340px;
  text-align: left;
  white-space: pre-wrap;
}

.detailTableLabel {
  width: 100px;
  text-align: left;
  background-color: #D1E6F5;
}
::v-deep .el-descriptions-item__label{
  align-items: center;
}

</style>